export * from '@devstroupe/services/config/config.service';
export * from '@devstroupe/services/config/config.types';
